export const getCurrentColors = (label?: string) => {
  const s = label?.toLowerCase() ?? '';
  if (s.includes('problem') || s.includes('return') || s.includes('reject'))
    return { sheet: 'bg-red-50 border-red-200', badge: 'bg-red-100 text-red-700 border-red-200' };
  if (s.includes('exception') || s.includes('hold') || s.includes('review'))
    return {
      sheet: 'bg-yellow-50 border-yellow-200',
      badge: 'bg-yellow-100 text-yellow-700 border-yellow-200',
    };
  return {
    sheet: 'bg-blue-50 border-blue-200',
    badge: 'bg-blue-100 text-blue-700 border-blue-200',
  };
};
